import { useState } from 'react';

import Button from '@/components/shared/Button/Button';
import { SubscriptionDetails } from '@addmile/backend-client';

import UpsertSubscriptionModal from '../UpsertSubscriptionModal/UpsertSubscriptionModal';
import SubscriptionsTable from './components/SubscriptionsTable';

interface UserBillingProps {
  subscriptions: SubscriptionDetails[];
}

const UserBilling = ({ subscriptions }: UserBillingProps) => {
  const [showUpsertSubscriptionModal, setShowUpsertSubscriptionModal] = useState(false);

  return (
    <>
      <Button
        label="Add Complimentary Subscription"
        className="mb-8"
        size="s"
        variant="secondary"
        onClick={() => setShowUpsertSubscriptionModal(true)}
      />
      <div className="flex justify-start gap-8 animation-appear">
        <SubscriptionsTable subscriptions={subscriptions} />
      </div>

      <UpsertSubscriptionModal
        isPopupOpen={showUpsertSubscriptionModal}
        closePopup={() => setShowUpsertSubscriptionModal(false)}
      />
    </>
  );
};

export default UserBilling;
